import type { TranslationKey } from '@/shared/i18n'

export const AREAS = [
  'residence',
  'tax',
  'insurance',
  'vehicle',
  'family',
  'banking',
  'other',
] as const

export type Area = (typeof AREAS)[number]

const icons: Record<Area, string> = {
  residence: '🏠',
  tax: '💰',
  insurance: '🛡',
  vehicle: '🚗',
  family: '👨‍👩‍👧',
  banking: '🏦',
  other: '📌',
}

export function isArea(candidate: string): candidate is Area {
  return (AREAS as readonly string[]).includes(candidate)
}

export function areaIcon(category: string): string {
  return isArea(category) ? icons[category] : icons.other
}

export function areaLabel(category: string): TranslationKey {
  return `area.${isArea(category) ? category : 'other'}` as TranslationKey
}
